import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as settings from "../../lib/air-api-constant";
import { FilterService } from '../filter/filter.service';
import { StorageService } from '../storage/storage.service';


@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  ETAThreshold: any;
  public isTransshipmentPromise = new BehaviorSubject<number>(0);
  public $isTransshipmentSubject = this.isTransshipmentPromise.asObservable();
  public isHazardousPromise = new BehaviorSubject<string>('N');
  public $isHazardousSubject = this.isHazardousPromise.asObservable();
  //For 34613
  public isDocsOnlyShipmentPromise = new BehaviorSubject<boolean>(false);
  public $isDocsOnlyShipment = this.isDocsOnlyShipmentPromise.asObservable();

  constructor(protected http: HttpClient, protected filterService: FilterService, protected storageService: StorageService) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
  }

  getTimeLineDetails(shipmentId: any) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    let url = settings.UserEndPoint.AirShipment.SHIPMENT_TIMELINES_DETAILS
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    // params = params.append("lateStatusMinRange", this.ETAThreshold ? this.ETAThreshold.minLimit : -5);
    // params = params.append("lateStatusMaxRange", this.ETAThreshold ? this.ETAThreshold.maxLimit : 5);
    // params = params.append("etaConfigType", this.ETAThreshold ? this.ETAThreshold.etaConfigType : 1);
    return this.http.get<any>(url, { params: params });
  }

  getPortOfCall(shipmentId: string | number | boolean) {
    let url = settings.UserEndPoint.Tracking.PORT_OF_CALL;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }

  getScheduleInfo(shipmentId: string | number | boolean) {
    let url = settings.UserEndPoint.Tracking.SCHEDULE_DETAILS;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }



  getRouteInfo(shipmentId: string | number | boolean) {
    let url = settings.UserEndPoint.Tracking.ROUTE_INFO;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }

  getLocationInfo(shipmentId: string | number | boolean) {
    let url = settings.UserEndPoint.Tracking.LOCATION_INFO;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }

  getEventsInfo(shipmentId: string | number | boolean) {
    let url = settings.UserEndPoint.Tracking.EVENTS_INFO;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }


  //#region  Direct link Api
  getDirectLink(body: any) {
    let url = settings.AirAppRoutes.DirectLink.DIRECT_LINK_KEY;
    return this.http.post<any>(url, body);
  }

  getDirectLinkAccess(key: string) {
    let url = `${settings.AirAppRoutes.DirectLink.DIRECT_LINK_ACCESS}/${key}`;
    return this.http.get<any>(url);
  }

  //#endregion

  updateDocsOnlyStatus(value: boolean) {
    this.isDocsOnlyShipmentPromise.next(value);
  }

  getDmsDocument(shipmentId: any, docTypeList: string): Observable<any> {
    let url = settings.UserEndPoint.smartDocuments.DMS_DOCUMENT;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    if (docTypeList && docTypeList.length > 0) {
      // console.log(docTypeList)
      params = params.set('docTypeIds', docTypeList);
      // params = params.set('docTypeIds', docTypeList.join(','));
    }
    else {
      params = params.append("docTypeIds", "");
    }
    let headers = new HttpHeaders().set('content-type', 'application/pdf');
    return this.http.get<ArrayBuffer>(url, { params: params, headers: headers, responseType: 'arraybuffer' as 'json', observe: 'response' });
  }

  getHasDocument(shipmentId: any) {
    let url = settings.UserEndPoint.smartDocuments.HAS_DOCUMENT;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get<any>(url, { params: params });
  }
  getShipmentInfo(shipmentId: string | number) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    let url = settings.UserEndPoint.Flight.SHIPMENT_INFO;
    let params = new HttpParams();
    params = params.append("shipment_id", shipmentId);
  ///  let body = { shipmentId: shipmentId };

    // params = params.append("lateStatusMinRange", this.ETAThreshold ? this.ETAThreshold.minLimit : -5);
    // params = params.append("lateStatusMaxRange", this.ETAThreshold ? this.ETAThreshold.maxLimit : 5);
    // params = params.append("etaConfigType", this.ETAThreshold ? this.ETAThreshold.etaConfigType : 1);
    return this.http.get<any>(url, { params: params });
  }

  getShipmentAllInfo(shipmentId: string | number | boolean) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    let url = settings.UserEndPoint.AirShipment.SHIPMENT_ALL_INFO;
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    // let params = new HttpParams();
    // params = params.append("shipmentId", shipmentId);
    // params = params.append("lateStatusMinRange", this.ETAThreshold ? this.ETAThreshold.minLimit : -5);
    // params = params.append("lateStatusMaxRange", this.ETAThreshold ? this.ETAThreshold.maxLimit : 5);
    // params = params.append("etaConfigType", this.ETAThreshold ? this.ETAThreshold.etaConfigType : 1);
    return this.http.get<any>(url, { params: params });
  }
}
